import { render, staticRenderFns } from "./signProcess.vue?vue&type=template&id=956b56f4&scoped=true&"
import script from "./signProcess.vue?vue&type=script&lang=js&"
export * from "./signProcess.vue?vue&type=script&lang=js&"
import style0 from "./signProcess.vue?vue&type=style&index=0&id=956b56f4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "956b56f4",
  null
  
)

export default component.exports